
/**
 * Promised based setTimeout delay
 * @param {number} t timestamp
 */
const delay = t => new Promise(resolve => setTimeout(resolve, t));
export default delay